import ButtonGroup from "@visa/vds/button-group";
import ButtonText from "@visa/vds/button-text";
import React from "react";

const ActionButtonGroup = (props) => {
  const handleClickReorder = () => {
    props.setIsReorder(!props.isReorder);
  };

  const handleClickSaveReorder = () => {
    props.handleClickSaveReorder(props.alertObj);
    props.setIsReorder(!props.isReorder);
  };

  const handleClickCancelReorder = () => {
    props.handleClickCancelReorder();
    props.setIsReorder(!props.isReorder);
  };

  return (
    <ButtonGroup direction="right">
      {!props.isReorder && (
        <ButtonText onClick={props.handleClickAdd}>
          {props.btnAddText ? props.btnAddText : "Add New"}
        </ButtonText>
      )}
      {!props.isReorder && (
        <ButtonText
          disabled={props.disableReorder}
          colorScheme="secondary"
          onClick={handleClickReorder}
        >
          Reorder
        </ButtonText>
      )}
      {props.isReorder && (
        <>
          <ButtonText colorScheme="primary" onClick={handleClickSaveReorder}>
            Save Reorder
          </ButtonText>
          <ButtonText colorScheme="tertiary" onClick={handleClickCancelReorder}>
            Cancel Reorder
          </ButtonText>
        </>
      )}
    </ButtonGroup>
  );
};

export default ActionButtonGroup;
